import { createAction, props } from '@ngrx/store';
import { IKpiResponse } from '../../../interfaces/kpi/IKpiResponse';

export const loadRasterKPI = createAction(
  '[KPI] Load Raster KPI',
  props<{ kpi_uuid: string, layer_uuid: string }>()
);

export const loadRasterKPISuccess = createAction(
  '[KPI] Load Raster KPI Success',
  props<{ kpi: IKpiResponse, layer_uuid: string }>()
);

export const loadRasterKPIFailure = createAction(
  '[KPI] Load Raster KPI Failure',
  props<{ error: any }>()
);

export const loadRasterKPIsByProject = createAction(
  '[KPI] Load Raster KPIs By Project',
  props<{ project_uuid: string }>()
);

export const loadRasterKPIsByProjectSuccess = createAction(
  '[KPI] Load Raster KPIs By Project Success',
  props<{ kpis: Array<{uuid : string , kpi_type : string, layer: string}> }>()
);

export const loadRasterKPIsByProjectFailure = createAction(
  '[KPI] Load Raster KPIs By Project Failure',
  props<{ error: any }>()
);
